import { Injectable } from "@angular/core";

export interface ParsedData {
  mimetype: string;
  data: string;
}

@Injectable({
  providedIn: "root",
})
export class DateFormattingService {
  format(date: Date): string {
    const dtf = new Intl.DateTimeFormat("en", {
      year: "numeric",
      month: "numeric",
      day: "2-digit",
    });
    const [{ value: mo }, , { value: da }, , { value: ye }] =
      dtf.formatToParts(date);
    return `${da}/${mo}/${ye}`;
  }
}
